<!--
 * @Author: Latte
 * @Date: 2021-05-27 16:34:31
 * @LAstEditors: Latte
 * @LastEditTime: 2021-10-28 11:51:49
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\mai\carousel-management\index.vue
-->
<template>
  <div class="app-container">
    <el-tabs v-model="activeIndex" type="border-card" @tab-click="handleClick" v-tab-change:activeIndex="setActiveName">
      <el-tab-pane
        v-for="item in tabList"
        :key="item.name"
        :label="item.label"
        :name="item.name"
      >
        <keep-alive>
          <component
            :is="item.name"
            v-if="item.name === activeIndex"
          ></component>
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import AppAd from "@/components/CarouselManagement/AppAd.vue";
import ForumGroup from "@/components/CarouselManagement/ForumGroup.vue";
import MaiLive from "@/components/CarouselManagement/MaiLive.vue";
import Product from "@/components/CarouselManagement/Product.vue";

export default {
  components: {
    AppAd,
    ForumGroup,
    MaiLive,
    Product
  },
  data() {
    return {
      activeIndex: "ForumGroup", // 当前索引
      tabList: [
        {
          name: "ForumGroup",
          label: "超人圈群组轮播图",
        },
        {
          name: "AppAd",
          label: "app广告轮播图",
        },
        {
          name: "MaiLive",
          label: "麦粒视频轮播图",
        },
        {
          name: "Product",
          label: "产品轮播图",
        },
      ],
    };
  },
  methods: {
    /**
     * 切换 tab
     */
    handleClick() {
      this.currentPage = 1;
    },
  },
};
</script>

<style scoped lang="scss"></style>
